module.exports = __webpack_public_path__ + "static/img/icon-check.4c44e27d.svg";